import * as React from 'react';

export function Cross(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8348 4.57945C17.2253 4.18893 17.2253 3.55576 16.8348 3.16524C16.4442 2.77471 15.8111 2.77471 15.4206 3.16524L10 8.58579L4.57945 3.16524C4.18893 2.77471 3.55576 2.77471 3.16524 3.16524C2.77471 3.55576 2.77471 4.18893 3.16524 4.57945L8.58579 10L3.16524 15.4206C2.77471 15.8111 2.77471 16.4442 3.16524 16.8348C3.55576 17.2253 4.18893 17.2253 4.57945 16.8348L10 11.4142L15.4206 16.8348C15.8111 17.2253 16.4442 17.2253 16.8348 16.8348C17.2253 16.4442 17.2253 15.8111 16.8348 15.4206L11.4142 10L16.8348 4.57945Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Cross;
